// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.organization-chart-page {
  padding: 30px;
  background: transparent;
  min-height: 100vh;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.page-title {
  color: #2c3e50;
  font-weight: 700;
  font-size: 1.5rem;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
  letter-spacing: 1px;
}

.tree-card {
  border: 2px solid #2c3e50;
  border-radius: 4px;
  background: transparent;
  overflow: hidden;
  transition: all 0.3s ease;
}

.tree-card:hover {
  border-color: #34495e;
  transform: translateY(-2px);
}

.tree-card .card-header {
  background: transparent;
  color: #2c3e50;
  border-radius: 0;
  border: none;
  border-bottom: 2px solid #2c3e50;
  font-weight: 600;
  padding: 20px 25px;
}

.tree-card .card-body {
  padding: 25px;
  background: transparent;
}

.chart-card {
  border: 2px solid #495057;
  border-radius: 4px;
  background: transparent;
  overflow: hidden;
  transition: all 0.3s ease;
}

.chart-card:hover {
  border-color: #6c757d;
  transform: translateY(-2px);
}

.chart-card .card-header {
  background: transparent;
  color: #495057;
  border-radius: 0;
  border: none;
  border-bottom: 2px solid #495057;
  font-weight: 600;
  padding: 20px 25px;
}

.chart-card .card-body {
  padding: 25px;
  background: transparent;
}

.functions-list-card {
  border: 2px solid #6c757d;
  border-radius: 4px;
  background: transparent;
  height: fit-content;
  overflow: hidden;
  transition: all 0.3s ease;
}

.functions-list-card:hover {
  border-color: #868e96;
  transform: translateY(-2px);
}

.functions-list-card .card-header {
  background: transparent;
  color: #6c757d;
  border-radius: 0;
  border: none;
  border-bottom: 2px solid #6c757d;
  font-weight: 600;
  padding: 20px 25px;
}

.functions-list-card .card-body {
  padding: 25px;
  background: transparent;
}

.functions-list {
  max-height: 400px;
  overflow-y: auto;
}

.function-item {
  display: flex;
  align-items: center;
  padding: 12px;
  margin-bottom: 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.function-item:hover {
  background-color: #f8f9fa;
  transform: translateX(5px);
}

.function-item.selected {
  background-color: #e3f2fd;
  border-color: #2196f3;
  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.2);
}

.function-color {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 12px;
  flex-shrink: 0;
}

.function-info {
  flex: 1 1;
}

.function-name {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 2px;
}

.function-count {
  font-size: 0.9em;
  color: #6c757d;
}

.user-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  max-height: 400px;
  overflow-y: auto;
}

.user-item {
  display: flex;
  align-items: center;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.user-item:hover {
  background: #e9ecef;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  margin-right: 12px;
  flex-shrink: 0;
}

.user-info {
  flex: 1 1;
}

.user-name {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 2px;
}

.user-email {
  font-size: 0.9em;
  color: #6c757d;
  margin-bottom: 2px;
}

.user-role {
  font-size: 0.8em;
  color: #28a745;
  background: #d4edda;
  padding: 2px 8px;
  border-radius: 12px;
  display: inline-block;
}

.custom-tooltip {
  background: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.tooltip-label {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 4px;
}

.tooltip-value {
  color: #495057;
  margin-bottom: 4px;
}

.tooltip-description {
  font-size: 0.9em;
  color: #6c757d;
  margin-bottom: 0;
  font-style: italic;
}

/* Responsive design */
@media (max-width: 768px) {
  .organization-chart-page {
    padding: 10px;
  }
  
  .user-list {
    grid-template-columns: 1fr;
  }
  
  .function-item {
    padding: 8px;
  }
  
  .user-item {
    padding: 8px;
  }
}

/* Loading and error states */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
}

.error-container {
  padding: 20px;
}

/* Chart interactions */
.recharts-bar-rectangle {
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.recharts-bar-rectangle:hover {
  opacity: 0.8;
}

.recharts-pie-sector {
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.recharts-pie-sector:hover {
  opacity: 0.8;
}

/* Badge styles */
.badge {
  font-size: 0.75em;
  padding: 4px 8px;
}

/* Button styles */
.btn {
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Traditional Org Chart Styles */
.tree-container {
  max-height: 600px;
  overflow-y: auto;
  padding: 30px;
  background: transparent;
  border-radius: 4px;
  border: 2px solid #e9ecef;
  position: relative;
}

.tree-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #2c3e50, #34495e, #5d6d7e, #85929e);
  border-radius: 4px 4px 0 0;
}

.tree-container.expanded {
  max-height: 800px;
}

.tree-view {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.org-chart-node {
  position: relative;
  margin: 10px 0;
}

.org-box {
  background: transparent;
  border: 2px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 200px;
  position: relative;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.org-box:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.org-box.ceo {
  background: transparent;
  color: #2c3e50;
  border: 2px solid #2c3e50;
  min-width: 250px;
  font-weight: 600;
}

.org-box.vp {
  background: transparent;
  color: #495057;
  border: 2px solid #495057;
  min-width: 220px;
  font-weight: 500;
}

.org-box.director {
  background: transparent;
  color: #6c757d;
  border: 2px solid #6c757d;
  min-width: 180px;
  font-weight: 500;
}

.org-box.user {
  background: transparent;
  color: #868e96;
  border: 2px solid #868e96;
  min-width: 160px;
  font-weight: 400;
}

.org-box-content {
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.org-box-icon {
  font-size: 20px;
  display: flex;
  align-items: center;
}

.role-icon.ceo {
  color: #2c3e50;
  font-size: 24px;
}

.role-icon.vp {
  color: #495057;
  font-size: 20px;
}

.role-icon.director {
  color: #6c757d;
  font-size: 18px;
}

.role-icon.user {
  color: #868e96;
  font-size: 16px;
}

.org-box-info {
  flex: 1 1;
}

.org-box-title {
  font-weight: inherit;
  font-size: 14px;
  margin-bottom: 3px;
}

.org-box-subtitle {
  font-size: 11px;
  opacity: 0.9;
}

.org-box-email {
  margin-bottom: 2px;
}

.org-box-role {
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 6px;
  border-radius: 10px;
  display: inline-block;
  font-size: 10px;
}

.org-box-count {
  font-weight: 500;
  margin-bottom: 2px;
}

.org-box-desc {
  font-style: italic;
  font-size: 11px;
}

.org-chart-children {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  margin-top: 40px;
  position: relative;
  flex-wrap: wrap;
  gap: 30px;
}

.org-chart-children::before {
  content: '';
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: 20px;
  background: #ddd;
}

/* Horizontal layout for VPs */
.org-chart-node.vp {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  position: relative;
}

/* VP container for horizontal layout */
.org-chart-children .org-chart-node.vp {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 200px;
}

/* Directors under each VP */
.org-chart-node.vp .org-chart-children {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
}

.org-chart-node.vp .org-chart-children::before {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: 10px;
  background: #ddd;
}

/* Director boxes */
.org-chart-node.director {
  margin: 5px 0;
  position: relative;
}

/* Connection lines for horizontal layout */
.org-chart-node.vp::before {
  content: '';
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: 20px;
  background: #ddd;
}

.org-chart-node.director::before {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: 10px;
  background: #ddd;
}

/* Horizontal connector line from CEO to VPs */
.org-chart-children::after {
  content: '';
  position: absolute;
  top: -20px;
  left: 0;
  right: 0;
  height: 2px;
  background: #ddd;
  z-index: 1;
}

/* Responsive design */
@media (max-width: 768px) {
  .tree-container {
    padding: 10px;
  }
  
  .org-box {
    min-width: 150px;
  }
  
  .org-box-content {
    padding: 10px;
  }
  
  .org-box-title {
    font-size: 14px;
  }
  
  .org-chart-children {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  
  .org-chart-children::after {
    display: none;
  }
}

/* Responsive tree */
@media (max-width: 768px) {
  .tree-container {
    max-height: 400px;
  }
  
  .node-content {
    padding: 6px 8px;
  }
  
  .node-name {
    font-size: 13px;
  }
  
  .node-details {
    font-size: 11px;
  }
}

/* Control Buttons */
.control-buttons {
  background: transparent;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 25px;
}

.control-buttons .btn {
  border-radius: 4px;
  padding: 10px 16px;
  font-weight: 500;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.control-buttons .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.control-buttons .btn-primary {
  background: transparent;
  border: 2px solid #2c3e50;
  color: #2c3e50;
}

.control-buttons .btn-success {
  background: transparent;
  border: 2px solid #28a745;
  color: #28a745;
}

.control-buttons .btn-outline-primary {
  color: #2c3e50;
  border-color: #2c3e50;
}

.control-buttons .btn-outline-primary:hover {
  background: #2c3e50;
  border-color: #2c3e50;
  color: white;
}

.control-buttons .btn-outline-secondary {
  color: #6c757d;
  border: 2px solid #6c757d;
  background: transparent;
}

.control-buttons .btn-outline-secondary:hover {
  background: #6c757d;
  border-color: #6c757d;
  color: white;
}

/* Card animations */
.card {
  transition: all 0.3s ease;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* Drag and Drop Styles */
.drag-handle {
  cursor: grab;
  padding: 8px;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  transition: all 0.2s ease;
}

.drag-handle:hover {
  background: rgba(0, 0, 0, 0.1);
  color: #495057;
}

.drag-handle:active {
  cursor: grabbing;
}

.org-box.drag-over {
  border-color: #007bff !important;
  background: transparent !important;
  transform: scale(1.02);
  box-shadow: 0 4px 20px rgba(0, 123, 255, 0.3) !important;
}

.org-box.dragging {
  opacity: 0.7;
  transform: scale(0.95);
}

.org-box.drag-over::after {
  content: 'Drop here';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #007bff;
  color: white;
  padding: 4px 8px;
  border-radius: 2px;
  font-size: 12px;
  font-weight: 500;
  z-index: 10;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/OrganizationChart/OrganizationChart.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,4DAA4D;AAC9D;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sEAAsE;EACtE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4DAA4D;EAC5D,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB","sourcesContent":[".organization-chart-page {\n  padding: 30px;\n  background: transparent;\n  min-height: 100vh;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.page-title {\n  color: #2c3e50;\n  font-weight: 700;\n  font-size: 1.5rem;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  text-align: center;\n  text-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  letter-spacing: 1px;\n}\n\n.tree-card {\n  border: 2px solid #2c3e50;\n  border-radius: 4px;\n  background: transparent;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.tree-card:hover {\n  border-color: #34495e;\n  transform: translateY(-2px);\n}\n\n.tree-card .card-header {\n  background: transparent;\n  color: #2c3e50;\n  border-radius: 0;\n  border: none;\n  border-bottom: 2px solid #2c3e50;\n  font-weight: 600;\n  padding: 20px 25px;\n}\n\n.tree-card .card-body {\n  padding: 25px;\n  background: transparent;\n}\n\n.chart-card {\n  border: 2px solid #495057;\n  border-radius: 4px;\n  background: transparent;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.chart-card:hover {\n  border-color: #6c757d;\n  transform: translateY(-2px);\n}\n\n.chart-card .card-header {\n  background: transparent;\n  color: #495057;\n  border-radius: 0;\n  border: none;\n  border-bottom: 2px solid #495057;\n  font-weight: 600;\n  padding: 20px 25px;\n}\n\n.chart-card .card-body {\n  padding: 25px;\n  background: transparent;\n}\n\n.functions-list-card {\n  border: 2px solid #6c757d;\n  border-radius: 4px;\n  background: transparent;\n  height: fit-content;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.functions-list-card:hover {\n  border-color: #868e96;\n  transform: translateY(-2px);\n}\n\n.functions-list-card .card-header {\n  background: transparent;\n  color: #6c757d;\n  border-radius: 0;\n  border: none;\n  border-bottom: 2px solid #6c757d;\n  font-weight: 600;\n  padding: 20px 25px;\n}\n\n.functions-list-card .card-body {\n  padding: 25px;\n  background: transparent;\n}\n\n.functions-list {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.function-item {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  margin-bottom: 8px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: 2px solid transparent;\n}\n\n.function-item:hover {\n  background-color: #f8f9fa;\n  transform: translateX(5px);\n}\n\n.function-item.selected {\n  background-color: #e3f2fd;\n  border-color: #2196f3;\n  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.2);\n}\n\n.function-color {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.function-info {\n  flex: 1;\n}\n\n.function-name {\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 2px;\n}\n\n.function-count {\n  font-size: 0.9em;\n  color: #6c757d;\n}\n\n.user-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 16px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.user-item {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n  transition: all 0.3s ease;\n}\n\n.user-item:hover {\n  background: #e9ecef;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.user-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 16px;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.user-info {\n  flex: 1;\n}\n\n.user-name {\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 2px;\n}\n\n.user-email {\n  font-size: 0.9em;\n  color: #6c757d;\n  margin-bottom: 2px;\n}\n\n.user-role {\n  font-size: 0.8em;\n  color: #28a745;\n  background: #d4edda;\n  padding: 2px 8px;\n  border-radius: 12px;\n  display: inline-block;\n}\n\n.custom-tooltip {\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  padding: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.tooltip-label {\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 4px;\n}\n\n.tooltip-value {\n  color: #495057;\n  margin-bottom: 4px;\n}\n\n.tooltip-description {\n  font-size: 0.9em;\n  color: #6c757d;\n  margin-bottom: 0;\n  font-style: italic;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .organization-chart-page {\n    padding: 10px;\n  }\n  \n  .user-list {\n    grid-template-columns: 1fr;\n  }\n  \n  .function-item {\n    padding: 8px;\n  }\n  \n  .user-item {\n    padding: 8px;\n  }\n}\n\n/* Loading and error states */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 400px;\n}\n\n.error-container {\n  padding: 20px;\n}\n\n/* Chart interactions */\n.recharts-bar-rectangle {\n  cursor: pointer;\n  transition: opacity 0.3s ease;\n}\n\n.recharts-bar-rectangle:hover {\n  opacity: 0.8;\n}\n\n.recharts-pie-sector {\n  cursor: pointer;\n  transition: opacity 0.3s ease;\n}\n\n.recharts-pie-sector:hover {\n  opacity: 0.8;\n}\n\n/* Badge styles */\n.badge {\n  font-size: 0.75em;\n  padding: 4px 8px;\n}\n\n/* Button styles */\n.btn {\n  border-radius: 6px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Traditional Org Chart Styles */\n.tree-container {\n  max-height: 600px;\n  overflow-y: auto;\n  padding: 30px;\n  background: transparent;\n  border-radius: 4px;\n  border: 2px solid #e9ecef;\n  position: relative;\n}\n\n.tree-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #2c3e50, #34495e, #5d6d7e, #85929e);\n  border-radius: 4px 4px 0 0;\n}\n\n.tree-container.expanded {\n  max-height: 800px;\n}\n\n.tree-view {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.org-chart-node {\n  position: relative;\n  margin: 10px 0;\n}\n\n.org-box {\n  background: transparent;\n  border: 2px solid #e0e0e0;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 200px;\n  position: relative;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.org-box:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.org-box.ceo {\n  background: transparent;\n  color: #2c3e50;\n  border: 2px solid #2c3e50;\n  min-width: 250px;\n  font-weight: 600;\n}\n\n.org-box.vp {\n  background: transparent;\n  color: #495057;\n  border: 2px solid #495057;\n  min-width: 220px;\n  font-weight: 500;\n}\n\n.org-box.director {\n  background: transparent;\n  color: #6c757d;\n  border: 2px solid #6c757d;\n  min-width: 180px;\n  font-weight: 500;\n}\n\n.org-box.user {\n  background: transparent;\n  color: #868e96;\n  border: 2px solid #868e96;\n  min-width: 160px;\n  font-weight: 400;\n}\n\n.org-box-content {\n  padding: 12px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.org-box-icon {\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n}\n\n.role-icon.ceo {\n  color: #2c3e50;\n  font-size: 24px;\n}\n\n.role-icon.vp {\n  color: #495057;\n  font-size: 20px;\n}\n\n.role-icon.director {\n  color: #6c757d;\n  font-size: 18px;\n}\n\n.role-icon.user {\n  color: #868e96;\n  font-size: 16px;\n}\n\n.org-box-info {\n  flex: 1;\n}\n\n.org-box-title {\n  font-weight: inherit;\n  font-size: 14px;\n  margin-bottom: 3px;\n}\n\n.org-box-subtitle {\n  font-size: 11px;\n  opacity: 0.9;\n}\n\n.org-box-email {\n  margin-bottom: 2px;\n}\n\n.org-box-role {\n  background: rgba(255, 255, 255, 0.2);\n  padding: 2px 6px;\n  border-radius: 10px;\n  display: inline-block;\n  font-size: 10px;\n}\n\n.org-box-count {\n  font-weight: 500;\n  margin-bottom: 2px;\n}\n\n.org-box-desc {\n  font-style: italic;\n  font-size: 11px;\n}\n\n.org-chart-children {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: flex-start;\n  margin-top: 40px;\n  position: relative;\n  flex-wrap: wrap;\n  gap: 30px;\n}\n\n.org-chart-children::before {\n  content: '';\n  position: absolute;\n  top: -20px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 2px;\n  height: 20px;\n  background: #ddd;\n}\n\n/* Horizontal layout for VPs */\n.org-chart-node.vp {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0;\n  position: relative;\n}\n\n/* VP container for horizontal layout */\n.org-chart-children .org-chart-node.vp {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 200px;\n}\n\n/* Directors under each VP */\n.org-chart-node.vp .org-chart-children {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n  gap: 10px;\n}\n\n.org-chart-node.vp .org-chart-children::before {\n  content: '';\n  position: absolute;\n  top: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 2px;\n  height: 10px;\n  background: #ddd;\n}\n\n/* Director boxes */\n.org-chart-node.director {\n  margin: 5px 0;\n  position: relative;\n}\n\n/* Connection lines for horizontal layout */\n.org-chart-node.vp::before {\n  content: '';\n  position: absolute;\n  top: -20px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 2px;\n  height: 20px;\n  background: #ddd;\n}\n\n.org-chart-node.director::before {\n  content: '';\n  position: absolute;\n  top: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 2px;\n  height: 10px;\n  background: #ddd;\n}\n\n/* Horizontal connector line from CEO to VPs */\n.org-chart-children::after {\n  content: '';\n  position: absolute;\n  top: -20px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: #ddd;\n  z-index: 1;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .tree-container {\n    padding: 10px;\n  }\n  \n  .org-box {\n    min-width: 150px;\n  }\n  \n  .org-box-content {\n    padding: 10px;\n  }\n  \n  .org-box-title {\n    font-size: 14px;\n  }\n  \n  .org-chart-children {\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n  }\n  \n  .org-chart-children::after {\n    display: none;\n  }\n}\n\n/* Responsive tree */\n@media (max-width: 768px) {\n  .tree-container {\n    max-height: 400px;\n  }\n  \n  .node-content {\n    padding: 6px 8px;\n  }\n  \n  .node-name {\n    font-size: 13px;\n  }\n  \n  .node-details {\n    font-size: 11px;\n  }\n}\n\n/* Control Buttons */\n.control-buttons {\n  background: transparent;\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 25px;\n}\n\n.control-buttons .btn {\n  border-radius: 4px;\n  padding: 10px 16px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  border: 1px solid transparent;\n}\n\n.control-buttons .btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.control-buttons .btn-primary {\n  background: transparent;\n  border: 2px solid #2c3e50;\n  color: #2c3e50;\n}\n\n.control-buttons .btn-success {\n  background: transparent;\n  border: 2px solid #28a745;\n  color: #28a745;\n}\n\n.control-buttons .btn-outline-primary {\n  color: #2c3e50;\n  border-color: #2c3e50;\n}\n\n.control-buttons .btn-outline-primary:hover {\n  background: #2c3e50;\n  border-color: #2c3e50;\n  color: white;\n}\n\n.control-buttons .btn-outline-secondary {\n  color: #6c757d;\n  border: 2px solid #6c757d;\n  background: transparent;\n}\n\n.control-buttons .btn-outline-secondary:hover {\n  background: #6c757d;\n  border-color: #6c757d;\n  color: white;\n}\n\n/* Card animations */\n.card {\n  transition: all 0.3s ease;\n}\n\n.card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n/* Drag and Drop Styles */\n.drag-handle {\n  cursor: grab;\n  padding: 8px;\n  color: #6c757d;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 2px;\n  transition: all 0.2s ease;\n}\n\n.drag-handle:hover {\n  background: rgba(0, 0, 0, 0.1);\n  color: #495057;\n}\n\n.drag-handle:active {\n  cursor: grabbing;\n}\n\n.org-box.drag-over {\n  border-color: #007bff !important;\n  background: transparent !important;\n  transform: scale(1.02);\n  box-shadow: 0 4px 20px rgba(0, 123, 255, 0.3) !important;\n}\n\n.org-box.dragging {\n  opacity: 0.7;\n  transform: scale(0.95);\n}\n\n.org-box.drag-over::after {\n  content: 'Drop here';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: #007bff;\n  color: white;\n  padding: 4px 8px;\n  border-radius: 2px;\n  font-size: 12px;\n  font-weight: 500;\n  z-index: 10;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
